export default __webpack_public_path__ + "static/media/map-icon-line-white.47d66d15.svg";